import type { EditRowDef } from '../../../types'
import { serializeFieldValue } from '../../../helpers/serializeFieldValue'

export function buildEditSubmitBody(
  rows: EditRowDef[],
  values: Record<string, unknown>
): Record<string, unknown> {
  return rows
    .filter((row) => row.mode === 'editable')
    .reduce<Record<string, unknown>>(
      (acc, row) => ({
        ...acc,
        [row.field.name]: serializeFieldValue(
          row.field,
          values[row.field.name]
        ),
      }),
      {}
    )
}
